export const CCPA_ANALYTICS = "cresco_ccpa_analytics";
export const ACCESSIBILITY = "cresco_accessibility";